import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { StopPropagationDirective } from '@modules/shared/directives/stop-propagation.directive';
import { TuiButton, TuiDialogContext, TuiDialogService, TuiHint, TuiHintDirective, TuiLink } from '@taiga-ui/core';
import { PolymorpheusContent } from '@taiga-ui/polymorpheus';
import { Subscription } from 'rxjs';

@Component({
  selector: 'pxc-sequence-description-dialog',
  imports: [TranslocoDirective, TuiButton, TuiLink, TuiHint, StopPropagationDirective, TuiHintDirective],
  templateUrl: './sequence-description-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SequenceDescriptionDialogComponent {
  @Input() description: string;
  @Input() iconOnly = false;

  dialogRef: Subscription;

  private readonly tuiDialogService = inject(TuiDialogService);
  private readonly transloco = inject(TranslocoService);

  openSequenceDescription(dialog: PolymorpheusContent<TuiDialogContext>): void {
    this.dialogRef = this.tuiDialogService
      .open(dialog, {
        label: this.transloco.translate('Description'),
      })
      .subscribe();
  }
}
